import React from 'react'
import { Typography } from "@mui/material"

import { alertsSection } from "Pages/ReportsAlerts/Alerts/@signals"


export default function AlertsSubtitle() {
	return <Typography variant="subtitle">{alertsSection.value}</Typography>
}